export default "__VITE_ASSET__EPaUulYp__"